/**
 * Generated runtime TestId mirror for frontend/src/components/identity/IdentityManagerSection.tsx.
 * DO NOT EDIT MANUALLY — re-run scripts/generate-testid-constants.py.
 *
 * Runtime mirror — same values as frontend/e2e/helpers/testids/. Help maps
 * under frontend/src/locales/ import this module to express computed-property
 * keys (e.g. `[XxxTestIds.fooBar]: '...'`).
 */

import type { TestIdPrefix } from "./types.ts";

export const IdentityManagerSectionTestIds = {
  managerSectionEmpty: "manager-section-empty",
  managerSectionError: "manager-section-error",
  managerSectionLoading: "manager-section-loading",
  sectionManager: "section-manager",
  linkManager: (rel_toIdentity_id: string) => `link-manager-${rel_toIdentity_id}`,
  linkManagerPrefix: () => "link-manager-" as TestIdPrefix,
  managerDisplayName: (rel_toIdentity_id: string) => `manager-display-name-${rel_toIdentity_id}`,
  managerDisplayNamePrefix: () => "manager-display-name-" as TestIdPrefix,
  managerIdentityType: (rel_toIdentity_id: string) => `manager-identity-type-${rel_toIdentity_id}`,
  managerIdentityTypePrefix: () => "manager-identity-type-" as TestIdPrefix
} as const;
